const APIManager = Object.create(
    {},
    {
        getAll: {
            value: collectionName => {
                return fetch(
                    `https://isles-database.herokuapp.com/${collectionName}`
                ).then(e => e.json());
            }
        },
        getStore: {
            value: storeId => {
                return fetch(
                    `https://isles-database.herokuapp.com/items?storeId=${storeId}&_sort=aisle&_order=asc`
                ).then(e => e.json());
            }
        },
        deleter: {
            value: (deleter, itemId) => {
                return fetch(
                    `https://isles-database.herokuapp.com/${deleter}/${itemId}`,
                    {
                        method: "DELETE"
                    }
                ).then(a => a.json());
            }
        },
        postStore: {
            value: storeName => {
                return fetch(`https://isles-database.herokuapp.com/stores`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(storeName)
                }).then(a => a.json());
            }
        },
        editStoreName: {
            value: (storeId, dataObject) => {
                return fetch(
                    `https://isles-database.herokuapp.com/stores/${storeId}`,
                    {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            name: dataObject
                        })
                    }
                ).then(a => a.json());
            }
        },
        postItem: {
            value: (quantity, itemName, aisle, archived, storeId, userId) => {
                return fetch(
                    `https://isles-database.herokuapp.com/items?storeId=${storeId}&_sort=aisle&_order=asc`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            quantity: quantity,
                            name: itemName,
                            aisle: aisle,
                            archived: archived,
                            storeId: storeId,
                            userId: userId
                        })
                    }
                ).then(a => a.json());
            }
        },
        patchItem: {
            value: (itemId, archived) => {
                return fetch(
                    `https://isles-database.herokuapp.com/items/${itemId}`,
                    {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            archived: archived
                        })
                    }
                ).then(a => a.json());
            }
        },

        editItems: {
            value: (itemId, dataObject) => {
                return fetch(
                    `https://isles-database.herokuapp.com/items/${itemId}`,
                    {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(dataObject)
                    }
                ).then(a => a.json());
            }
        }
    }
);

export default APIManager;



// WEBPACK FOOTER //
// ./src/APIManager.js